export { ActiveStakes } from './submodules/ActiveStakes';
export { HistoryStakes } from './submodules/HistoryStakes';
import SidebarStakes from './submodules/SidebarStakes';

export { SidebarStakes };
